export default __webpack_public_path__ + "static/media/paper13.a94cbb91.JPG";